<div class="view-deploy h-full w-full flex">
	<div class="domain w-full">
		<div class="tabs w-full flex justify-end items-center p-4">
			<app-tabs [tabs]="tabs" [view]="'1'"></app-tabs>
		</div>
		<div class="content p-10 overflow-y-auto flex flex-col justify-start h-[calc(100vh-305px)]">
			<div class="config-dns w-full">
				<div class="title-dns flex w-full">
					<span class="pr-7 text-xl font-lato text-complementary-color-a">
						Configuración de DNS
					</span>
					<span
						class="px-3 py-1 rounded-lg w-24 text-center"
						[ngStyle]="{ background: '#E0FAD9', color: '#8DBC80' }"
					>
						Active
					</span>
				</div>
				<div class="content-dns w-full">
					<div class="content-config">
						<div class="text-base">Name</div>
						<div class="text-base">Code</div>
						<div class="text-base">Url</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">
							dam-tigres-master
						</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">CNAME</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">
							dg5mi7cxcdfqz.cloudfront.net
						</div>
					</div>
				</div>
			</div>
			<div class="config-ssl w-full mt-6">
				<div class="title-dns flex w-full">
					<span class="pr-7 text-xl font-lato text-complementary-color-a">
						Configuración de SSL
					</span>
				</div>
				<div class="content-dns w-full">
					<div class="content-config">
						<div class="font-lato text-base">Name</div>
						<div class="font-lato text-base">Code</div>
						<div class="font-lato text-base">Url</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">
							_1c42273eea5e77cdd63704...
						</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">CNAME</div>
						<div class="con1 text-complementary-color-b font-lato text-xl truncate">
							b43c797d8d06cf3121497628e2342342342342342342342j34j234hj24
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="help w-96 border-l border-neutral-color-c h-full p-10">
		<div class="content-help">
			<div class="title-help flex justify-start items-center">
				<mat-icon class="material-icons-outlined text-primary-color">info</mat-icon>
				<span class="pl-4 font-lato text-xl">Help</span>
			</div>
			<div class="text">
				<p class="text-justify font-lato text-sm pt-3 leading-4">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent varius eget ante ut
					euismod. Nullam sit amet luctus tortor. Phasellus leo ligula, rutrum nec tincidunt vitae,
					suscipit non lectus.   Donec ultrices aliquam dolor nec ornare. Suspendisse egestas lorem
					nec sem viverra pretium. Pellentesque in augue porta, mattis mauris id, porta ipsum.
					  Pellentesque neque diam, euismod vitae est ut, accumsan eleifend justo. Etiam dignissim
					dignissim eros, sit amet rutrum mi accumsan vitae. Curabitur semper congue nisi vehicula
					blandit. Mauris gravida tincidunt tincidunt. Nam in auctor nibh. Fusce vitae pretium
					dolor. Phasellus iaculis in lectus ac eleifend. Nulla et mauris ipsum. Link 1: Link 2:
					Link 3:
				</p>
			</div>
		</div>
	</div>
</div>
